import { useEnableV2FeedPage } from 'mednet-cns/src/hooks/gregorFlags'

export default function useHomePath() {
  const enableV2FeedPage = useEnableV2FeedPage()

  const homePath = enableV2FeedPage ? '/v2/feed' : '/home/index'
  const isHomePathExternal = enableV2FeedPage

  return {
    homePath,
    isHomePathExternal,
  }
}
